// extracted by mini-css-extract-plugin
module.exports = {"icon-wrap":"style_icon-wrap___U8aK"};